<div class="psdk-data-readonly">
  <div *ngIf="displayAs$=='Paragraph'" class="mat-body-1">{{content$}}</div>
  <div *ngIf="displayAs$=='Heading 1'" class="mat-h1">{{content$}}</div>
  <div *ngIf="displayAs$=='Heading 2'" class="mat-h2">{{content$}}</div>
  <div *ngIf="displayAs$=='Heading 3'" class="mat-h3">{{content$}}</div>
  <div *ngIf="displayAs$=='Heading 4'" class="mat-h4">{{content$}}</div>
</div>
